<template>
  <div>
    <!--account settings-->
    <div class="settings__account--profile">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            Your <span>profile</span>
          </div>
        </div>
        <div class="panel__content panel__content--grey">
          <div class="settings__form-container">
            <form action="" class="form--flex-items">
              
              <!--username-->
              <div class="form__item">
                <label  class="inline">Your <span>Name</span></label>
                <div class="form__item__input--half">
                  <input type="text" class="form__input" v-model="userDetails.name" disabled>
                </div>
                <div class="form__item__input--half">
                  <input type="text" class="form__input" v-model="userDetails.surname" disabled>
                </div>
              </div>
              
              <!--email address-->
              <div class="form__item">
                <label  class="inline">Your <span>email address</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input " v-model="userDetails.email" disabled>
                </div>
              </div>

              <!--confirm password-->
              <div class="form__item" v-if="changePassword">
                <label  class="inline">Old <span>password</span></label>
                <div class="form__item__input">
                  <input :type="passwordFieldType" type="text" class="form__input " v-model="userDetails.password" required>
                </div>
              </div>
              
              <!--password-->
              <div class="form__item">
                <label  class="inline">Password</label>
                <div class="form__item__input">
                  <input :type="passwordFieldType" type="text" class="form__input " v-if="!changePassword" v-model="userDetails.newPassword" required disabled>
                  <input :type="passwordFieldType" type="text" class="form__input " autocomplete="new-password" v-if="changePassword" v-model="userDetails.newPassword" required>
                  <span class="other-options__trigger" @click="changePassword = !changePassword">Change</span>
                  <span class="other-options__trigger" style="margin-right: 54px;" v-if="changePassword" @click="changeInitialPassword()">Save | </span>
                  <!--<span class="other-options__trigger" style="margin-right: 54px;" v-if="changePassword" @click="">Save | </span>-->
                  <!--<button class="btn btn&#45;&#45;primary align-end" v-if="changePassword" @click="changeInitialPassword()">Save changes</button>-->
                  <!--<button type="password" v-if="changePassword" @click="switchVisibility()">show / hide</button>-->
                </div>
              </div>
  
              <!--confirm password-->
              <div class="form__item" v-if="changePassword">
                <label  class="inline">Confirm <span>password</span></label>
                <div class="form__item__input">
                  <input :type="passwordFieldType" type="text" class="form__input " v-model="userDetails.confirmNewPassword" required>
                  <span class="other-options__trigger" type="password" v-if="changePassword && passwordFieldType === 'text' " @click="switchVisibility()">Hide</span>
                  <span class="other-options__trigger" type="password" v-if="changePassword && passwordFieldType === 'password' " @click="switchVisibility()">Show</span>
                </div>
              </div>


              <div class="form__item">
                <label  class="inline">Your <span>Phone number</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input " v-model="userDetails.number" disabled>
                </div>
              </div>

              <div class="form__item">
                <label  class="inline">Your <span>business</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input " v-model="userDetails.business" disabled>
                </div>
              </div>

              <div class="form__item">
                <label  class="inline"><span>business description</span></label>
                <div class="form__item__input">
                  <input type="text" class="form__input " v-model="userDetails.description" disabled>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>

    <div class="modal fade in"
         id="ConfirmationModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="ConfirmationModal" style="display: block;" v-if="changeInitiated">

      <div class="modal__dialog modal__dialog--xlg">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
                          <span class="time-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              id="Capa_1"
                              x="0px"
                              y="0px"
                              width="512px"
                              height="512px"
                              viewBox="0 0 612 612"
                              style="enable-background:new 0 0 612 612;"
                              xml:space="preserve"
                              class="icon--sm"
                            >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
                          </span>
              Approve Transfer
            </div>
            <button
              type="button"
              class="close btn btn--default btn--sm"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
              @click="change()"
            >
              <span>Close</span>
            </button>
          </div>

          <div class="modal__body modal__body--pad">
            <div class="disburse__result text-center">
              <div v-if="passwordChangeSuccessful">
                <!--success icon-->
                <div class="result-img">
                  <svg
                    class="icon icon--custom-big"
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline
                      points="38 15 22 33 12 25"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text"
                >Password Successfully Updated</p>
                <button
                  aria-label="Close"
                  data-dismis="modal"
                  class="btn btn--primary"
                  @click="change()"
                >Close</button>
              </div>

              <div v-if="passwordChangeFailed">
                <div class="result-img">
                  <svg
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon--custom-big"
                  >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline
                      points="16 34 25 25 34 16"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                    <polyline
                      points="16 16 25 25 34 34"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p v-for="error in passwordErrors" class="disburse__result__error error-text"
                >{{error}}</p>
                <button
                  class="btn btn--primary"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="change2()"
                >Try Again</button>
              </div>
            </div>
            <!--</div>-->
          </div>

        </div>
      </div>
    </div>

  </div>



</template>

<script>
    import {getUser, changeUserPassword} from '../../utils/user/getUserDetails'

  export default {
    created(){
      this.getProfileDetails();
    },

    data() {
      return {
        userDetails: {
          country:'Nigeria',
          name: '',
          surname: '',
          email: '',
          password: '',
          newPassword: '',
          confirmNewPassword: '',
          number: '',
          business: '',
          description: ''
        },
        changePassword: false,
        changeInitiated: false,
        passwordChangeSuccessful: false,
        passwordChangeFailed: false,
        passwordErrors: [],
        passwordFieldType: 'password'
      }
    },
    
    components:{
    
    },
    methods:{
      getProfileDetails(){
          getUser().then((response) => {
              if(response.status === 200){
                  if(response.data.phonenumber === null) {
                      response.data.phonenumber = ''
                  }
                  this.userDetails.number = response.data.phonenumber;
                  this.userDetails.email = response.data.email;
                  this.userDetails.name = response.data.name;
                  this.userDetails.surname = response.data.surname;
                  Object.keys(response.data.merchants).forEach((data)=>{
                      if(window.localStorage.getItem('merchantId') === response.data.merchants[data].id.toString()){
                          this.userDetails.business = response.data.merchants[data].name;
                          if(response.data.merchants[data].description === null) {response.data.merchants[data].description = ''}
                          this.userDetails.description = response.data.merchants[data].description;

                      }
                  });
              }
          }).catch((error) => {
              console.log(error);
          })
      },
        changeInitialPassword(){
          this.passwordErrors = [];
          if(this.userDetails.password !== '' && this.userDetails.newPassword !== '' && this.userDetails.confirmNewPassword !== ''){
              this.$Progress.start();
              if(this.userDetails.newPassword === this.userDetails.confirmNewPassword){
                  changeUserPassword(this.userDetails.email, this.userDetails.password, this.userDetails.newPassword)
                      .then((response) => {
                          this.$Progress.finish();
                          this.changeInitiated = true;
                          this.passwordChangeSuccessful = true;
                          this.passwordChangeFailed = false;
                      })
                      .catch((error) => {
                          this.$Progress.fail();
                          console.log(error.response.data.message);
                          this.changeInitiated = true;
                          this.passwordErrors.push(error.response.data.message);
                          this.passwordChangeSuccessful = false;
                          this.passwordChangeFailed = true;
                      })
              }
              else{
                  this.$Progress.fail();
                  this.changeInitiated = true;
                  this.passwordErrors.push('Passwords do not match');
                  this.passwordChangeSuccessful = false;
                  this.passwordChangeFailed = true;
              }

          }
          // else{
          //     alert('All fields must be entered')
          // }
      },
      change(){
          this.changeInitiated = false;
          this.passwordChangeFailed = false;
          this.passwordChangeSuccessful = false;
          this.passwordErrors = [];
          this.changePassword = false;
          this.userDetails.password = '';
          this.userDetails.newPassword = '';
          this.userDetails.confirmNewPassword = '';
      },
      change2(){
          this.changeInitiated = false;
          this.passwordChangeFailed = false;
          this.passwordChangeSuccessful = false;
          this.passwordErrors = [];
      },
      switchVisibility() {
          this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .panel__footer__right{
    .btn--default{
      margin-right:8px;
    }
  }
  .select__icon{
    top:12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/ProfileSettings.vue